import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { Plane, ArrowLeft, LogOut } from "lucide-react";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import ThemeToggle from "@/components/ThemeToggle";
import NotificationBell from "@/components/dashboard/NotificationBell";
import NAV_TABS from "./navConfig";

export default function StudentHeader({ game, team, gameId, activeTab, setActiveTab }) {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <header className="topbar">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left */}
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/games")}
              className="text-slate-400 hover:text-white hover:bg-slate-800"
              data-testid="back-to-lobby-btn"
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div className="flex items-center gap-3">
              <img src="/skyboard-logo.png" alt="SkyBoard" className="h-10 w-auto" />
              <div>
                <h1 className="text-lg font-heading font-bold text-white tracking-wide">
                  {team?.name || "SKYBOARD"}
                </h1>
                <p className="text-xs text-slate-400">
                  {team?.airline_code} • Q{game?.current_quarter} of {game?.quarters_count}
                </p>
              </div>
            </div>
          </div>

          {/* Center nav */}
          <nav className="hidden md:flex items-center gap-1">
            {NAV_TABS.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors border-b-2 ${
                  activeTab === tab.id
                    ? "text-white border-sky-500"
                    : "text-slate-400 border-transparent hover:text-white"
                }`}
                data-testid={`nav-tab-${t(tab.labelKey).toLowerCase()}`}
              >
                <tab.icon className="w-4 h-4" />
                {t(tab.labelKey)}
              </button>
            ))}
          </nav>

          {/* Right */}
          <div className="flex items-center gap-2">
            <LanguageSwitcher variant="header" />
            <ThemeToggle />
            <NotificationBell gameId={gameId} />
            <div className="text-right hidden sm:block">
              <p className="text-sm text-white font-medium">{user?.name}</p>
              <p className="text-xs text-slate-400">{game?.name}</p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => { logout(); navigate("/login"); }}
              className="text-slate-400 hover:text-white hover:bg-slate-800"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
